import { useEffect, PropsWithChildren } from 'react';
import { useGlobalContext } from '../../contexts';
import { setLanguage } from '$core/helpers/global';

const AppInitializer = ({ children }: PropsWithChildren<{}>) => {
  const { language } = useGlobalContext();

  useEffect(() => {
    setLanguage(language); // Aggiorna il valore globale della lingua
  }, [language]);

  return children as React.ReactElement;
};

export { AppInitializer };
